export const SET_NOTIFICATION_MARK = 'SET_NOTIFICATION_MARK';
